import React, { Component } from 'react';
import axios from 'axios'

import withStyles from '@mui/styles/withStyles';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import EditIcon from '@mui/icons-material/Edit';
import PeopleIcon from '@mui/icons-material/People';
import ListIcon from '@mui/icons-material/ViewList';
import ReceiptIcon from '@mui/icons-material/Receipt';
import Alert from '@mui/material/Alert';

import styles from "../styles";
import PageHeader from "../helper/PageHeader";
import Loading from '../helper/Loading';
import Error from '../helper/Error';

class Employers extends Component {
    constructor(props) {
        super(props);
        this.token = sessionStorage.getItem('accessToken');

        this.state = {
            loading: false,
            employers: [],
            employer: '',
            memberType: undefined,
            //employerContact: undefined,
            error: null,
            isDeleteDialogOpen: false,
            itemToDelete: ''
        }
    }

    handleDeleteDialogOpen = () => {
        this.setState({ isDeleteDialogOpen: true });
    };

    handleDeleteDialogClose = () => {
        this.setState({ isDeleteDialogOpen: false });
    };

    onNew = (event) => {
        this.props.history.push('/dashboard/employer/new/' + this.props.match.params.username);
    }

    onEdit = (event) => {
        this.props.history.push('/dashboard/employer/edit/' + this.state.employer);
    }

    onEditContacts = (event) => {
        this.props.history.push('/dashboard/employer/contacts/' + this.state.employer);
    }

    onTrainee = (event) => {
        let id =  this.state.employer;
        this.props.history.push('/dashboard/employer/trainee/' + id);
    }

    onCreditHistory = (event) => {
        let id =  this.state.employer;
        this.props.history.push('/dashboard/creditHistory/employer/' + id);
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    onEmployerSelect = (event) => {
        let selected = this.state.employers.find(e => e.value === event.target.value);
        console.log(selected);
        //let selected = {value: em.id, label: em.label, memberType: em.memberType}
        sessionStorage.setItem('selectedEmployer', JSON.stringify(selected));     

        //sessionStorage.setItem('selectedEmployer', selected);
        sessionStorage.setItem('selectedEmployerMembership', selected.memberType);
        console.log(sessionStorage.getItem('selectedEmployer'));
        this.setState({ 
            employer: selected.value,
            memberType: selected.memberType
        });
    }


    onDeleteEmployer = (event) => {
        event.preventDefault();
        // let groupID = event.currentTarget.getAttribute('data-tag');
        this.handleDeleteDialogClose();
        let employerID = this.state.employer.value;

        let url = '/api/usergroup/' + employerID;
        axios(url, {
            method: 'DELETE',
            headers: {
                'Authorization': this.token
            }
        }).then(response => {
            if (response.status >= 400) {
                throw new Error(response.statusText);
            }

            this.refresh();
        }).catch(err => {
            this.setState({ error: err.message });
        });
    }

    hideError = () => {
        this.setState({ error: '' })
    }

    refresh() {
        /*process.env.REACT_APP_SERVER + */
        this.setState({ loading: true })
        let url = '/api/groupuser/group/' + this.props.match.params.username;
        axios(url, {
            method: 'GET'
        })
            .then(res => res.data)
            .then(result => {
                let employers = [];

                result.groups.forEach((e) => {
                    if (e.type === 'Employer') {
                        employers.push({value: e.id, label: e.name, memberType: e.memberType});
                    }
                });
                let selectedEmployer =  JSON.parse(sessionStorage.getItem('selectedEmployer'));
                console.log(JSON.stringify(selectedEmployer))
                //console.log(selectedEmployer.value)
                let selectedMembership = sessionStorage.getItem('selectedEmployerMembership');
                let employer = selectedEmployer ? selectedEmployer.value : employers.length > 0 ? employers[0].value : '';
                let memberType = selectedMembership ? selectedMembership : employers.length > 0 ? employers[0].memberType : '';
                //set the selectedEmployer cache if it wasn't set and we default the selected to the first item
                if (!selectedEmployer && employers.length > 0) {
                    sessionStorage.setItem('selectedEmployer', JSON.stringify({value:employers[0].value, label: employers[0].label}));     
                    selectedEmployer =  JSON.parse(sessionStorage.getItem('selectedEmployer'));
                    console.log(JSON.stringify(selectedEmployer))
                }
                this.setState({
                    employers: employers,
                    employer: employer,
                    memberType: memberType,
                    loading: false 
                });

            }).catch(error => {
                this.setState({ 
                    error: error.message,
                    loading: false 
                });
            });
    }

    componentDidMount() {
        this.refresh();
        console.log(this.state.employer)
        console.log(this.state.employers)
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state,callback)=>{
            return;
        };
    }

    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if ((this.props.employers !== this.state.employers) && (this.props.employers !== undefined)) {
            this.setState({
                employers: this.props.employers
            })
        }
    }

    render() {
        const { classes } = this.props;

        if (this.state.error) {
            return <div>
                <br />
                <Alert severity="error" onClose={this.hideError}>{this.state.error}</Alert>
                <br />
            </div>
        }

        if (this.state.error !== null) return <Error />;

        // issue if no groups found keeps loading up
        // if (this.state.groups.length === 0) return <Loading />;
        if (this.state.loading) return <Loading />

        //move this to below header
        // if (this.state.groups.length === 0) return <NoDataFound message="No groups found" />;

        return (
            <div>
                <PageHeader
                    title={"For Employers"}
                />
                <Grid container  justifyContent="space-around"  alignItems="center">

                    <Grid item xs={12} md={8} style={{ textAlign: "left", alignSelf: "flex-start" }}>
                        <p>Select or create an Employer Account below to:</p>
                        <ul>
                            <li>Pay for multiple employees' online training with a single purchase</li>
                            <li>Give employees "credit" to pay for the online training/test before they create an account</li>
                            <li>Track employees' online training/test progress and results</li>
                            <li>Look up certificate IDs for employee online training/tests you purchased</li>
                        </ul>
                        <p>You can create one or more "Employer" accounts and share access with co-workers as needed.</p>
                    </Grid>
                </Grid>
                <Grid container direction="row" justifyContent="space-between" spacing={3}>
                    <Grid item xs={9} sm={9}>
                        <TextField
                            id="employer"
                            name="employer"
                            className={[classes.textField].join(' ')}
                            value={this.state.employer}
                            onChange={this.onEmployerSelect}
                            select
                            fullWidth
                            label="Select Employer"
                            
                        >
                            {this.state.employers.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            className={[].join(' ')}
                            onClick={this.onNew}
                            >
                            Create New Employer
                        </Button>
                    </Grid>

                </Grid>
                <br/>
                {(this.state.employer && this.state.memberType === 'Owner') &&
                <Grid container direction="row" justifyContent="space-between" alignItems="center">
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={[].join(' ')}
                        onClick={this.onEditContacts}
                        startIcon={<PeopleIcon />}
                        >
                        Employer Admin
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={[].join(' ')}
                        onClick={this.onEdit}
                        startIcon={<EditIcon />}
                    >
                    Edit
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={[].join(' ')}
                        onClick={this.onTrainee}
                        startIcon={<ListIcon />}
                    >
                        Employee Training
                    </Button>
                     <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        className={[].join(' ')}
                        onClick={this.onCreditHistory}
                        startIcon={<ReceiptIcon />}
                    >
                        Purchase History
                    </Button>
                </Grid>
                }
                            
            </div>
        );
    }
}

// export default Employers;
export default withStyles(styles, { withTheme: true })(Employers);
